/**
 * Contrato do item de menu "Setores Hospitalares" (US-60388).
 *
 * `SUBMODULO_KEY` já seedado por `src/AutolacMigrations/SqlScripts/Migrations/usuarios/
 * 054_MenuGrupoCadastrosEstabelecimentoSaude.sql` (prefixo `cadastro_` para não colidir com
 * `fila_coleta`, ver comentário na própria migration) — este valor precisa bater
 * EXATAMENTE com o seedado, não é um valor a definir livremente aqui. Sem esse valor exato,
 * o gate de permissão do sidebar (`SidebarComponent`) e o `opensAsOverlay` não encontram o
 * item na árvore e o pulo do próximo clique (launcher) nunca dispara.
 */
export const SETORES_HOSPITALARES_SUBMODULE_KEY = 'cadastro_setores_hospitalares';

/** Chave de permissão verificada via `PermissionService.checkPermission()` (Cenário 2). */
export const SETORES_HOSPITALARES_PERMISSION_KEY = 'SETORES_HOSPITALARES';
